import React from "react";

export default () => {
  return (
    <div className="search-results__spinner" aria-label="waiting..."><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  );
};
